"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { useAuth } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { useWavesV2 } from "./useWavesV2";
import { SIDEBAR_WAVES_OVERVIEW_REFETCH_INTERVAL_MS, WAVE_FOLLOWING_WAVES_PARAMS } from "@/components/react-query-wrapper/utils/query-utils";
const useDmWavesList = () => {
  const $ = _c(19);
  const {
    address
  } = useSeizeConnectContext();
  const {
    activeProfileProxy
  } = useAuth();
  activeProfileProxy?.id;
  let t0;
  bb0: {
    if (!address) {
      t0 = null;
      break bb0;
    }
    let t1;
    if ($[0] !== address) {
      t1 = address.toLowerCase();
      $[0] = address;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const normalizedAddress = t1;
    if (activeProfileProxy?.id) {
      t0 = `${normalizedAddress}:proxy:${activeProfileProxy.id}`;
      break bb0;
    }
    t0 = `${normalizedAddress}:primary`;
  }
  const viewerIdentityKey = t0;
  let t1;
  if ($[2] !== viewerIdentityKey) {
    t1 = {
      overviewType: WAVE_FOLLOWING_WAVES_PARAMS.initialWavesOverviewType,
      pageSize: WAVE_FOLLOWING_WAVES_PARAMS.limit,
      directMessage: true,
      viewerIdentityKey,
      refetchInterval: SIDEBAR_WAVES_OVERVIEW_REFETCH_INTERVAL_MS,
      refetchIntervalInBackground: false
    };
    $[2] = viewerIdentityKey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    waves: mainWaves,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    status,
    refetch
  } = useWavesV2(t1);
  let t2;
  if ($[4] !== mainWaves) {
    t2 = [...mainWaves].sort(_temp);
    $[4] = mainWaves;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const sorted = t2;
  const addPinnedWave = _temp2;
  const removePinnedWave = _temp3;
  let t3;
  if ($[6] !== fetchNextPage) {
    t3 = () => fetchNextPage();
    $[6] = fetchNextPage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const fetchNextPageStable = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fetchNextPageStable || $[11] !== hasNextPage || $[12] !== isFetching || $[13] !== isFetchingNextPage || $[14] !== mainWaves || $[15] !== refetch || $[16] !== sorted || $[17] !== status) {
    t6 = {
      waves: sorted,
      isFetching,
      isFetchingNextPage,
      hasNextPage,
      fetchNextPage: fetchNextPageStable,
      status,
      pinnedWaves: t4,
      isPinnedWavesLoading: false,
      hasPinnedWavesError: false,
      addPinnedWave,
      removePinnedWave,
      mainWaves,
      missingPinnedIds: t5,
      mainWavesRefetch: refetch,
      refetchAllWaves: refetch
    };
    $[10] = fetchNextPageStable;
    $[11] = hasNextPage;
    $[12] = isFetching;
    $[13] = isFetchingNextPage;
    $[14] = mainWaves;
    $[15] = refetch;
    $[16] = sorted;
    $[17] = status;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default useDmWavesList;
function _temp(a, b) {
  return (b.latestDropTimestamp ?? 0) - (a.latestDropTimestamp ?? 0);
}
function _temp2() {}
function _temp3() {}